import { Button, Form, InputNumber, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import I18n from "../../common/I18n";
import EndUserTitle from "../common/EndUserTitle";
import _ from "lodash";

const DriverWeeklySettlements = ({
	data = [],
	form,
	handleSave,
}) => {
	const [tableData, setTableData] = useState([])
	const decimalPoints = window.localStorage.getItem('round_off_decimals')

	useEffect(() => {
		setTableData([...data])
	}, [data]);

	const handleValueChange = (id, element, value) => {
		const records = [...tableData]
		const rowIndex = _.findIndex(records, { id: id });
		if (rowIndex >= 0) {
			records[rowIndex][element] = value
			setTableData(records)
		}
	}

	const columns = [
		{
			title: `${I18n.t('general.hawb')}`,
			dataIndex: "hawb",
			editable: false,
			render: (data, record) => {
				return <span>{data}</span>
			}
		},
		{
			title: `${I18n.t('account.account')}`,
			dataIndex: "account_code",
			editable: false,
			render: (data, record) => {
				return <span>{data}</span>
			}
		},
		{
			title: <EndUserTitle />,
			dataIndex: "consignee_name",
			className: 'noWrap',
			editable: false,
		},
		{
			title: "Vehicle Type",
			dataIndex: "vehicle_type",
			editable: false,
			render: (data, record) => {
				return <span>{data ? data : 'NA'}</span>
			}
		},
		{
			title: "Status",
			dataIndex: "status",
			editable: false,
			width: 120,
			render: (data, record) => {
				return <span>{data}</span>
			}
		},
		{
			title: (
				<div>
					{I18n.t('reports.gross_revenue')}
					<sup className="textRed">*</sup> ({I18n.t('general.price_symbol')})
				</div>
			),
			dataIndex: "gross_revenue",
			editable: false,
			render: (text, record, index) => (
				<InputNumber
					value={text}
					size="small"
					className="fontSize12"
					onChange={(value) => handleValueChange(record.id, "gross_revenue", value)}
					placeholder={I18n.t('reports.gross_revenue')}
					precision={decimalPoints}
					style={{ width: 100 }}
				/>
			),
			width: 125,
		},
		{
			title: (
				<div>
					{I18n.t('reports.gross_pay')}
					<sup className="textRed">*</sup> ({I18n.t('general.price_symbol')})
				</div>
			),
			dataIndex: "gross_pay",
			editable: false,
			render: (text, record, index) => (
				<InputNumber
					value={text}
					size="small"
					className="fontSize12"
					onChange={(value) => handleValueChange(record.id, "gross_pay", value)}
					placeholder={I18n.t('reports.gross_pay')}
					precision={decimalPoints}
					style={{ width: 100 }}
				/>
			),
			width: 110,
		}
	]
	return (
		<Form form={form} component={false}>
			<Table
				dataSource={tableData}
				columns={columns}
				rowClassName="editable-row"
				pagination={false}
				bordered
			/>
			<Row className="alignRight" style={{ marginTop: "16px" }}>
				<Button
					type="primary"
					onClick={() => handleSave(tableData)}
				>Save</Button>
			</Row>
		</Form>
	);
}

const WrappedWeeklySettlements = Form.create()(DriverWeeklySettlements)

export default WrappedWeeklySettlements;